import { useEffect, useState } from "react";
import { Copy, RefreshCw } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { adminApi, errMsg } from "@/lib/api";

export function ReferralConfigCard() {
  const [cfg, setCfg] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { adminApi.get("/referrals/config").then((r) => setCfg(r.data)).catch((e) => toast.error(errMsg(e))); }, []);
  if (!cfg) return null;
  const save = async () => {
    setBusy(true);
    try { setCfg((await adminApi.put("/referrals/config", { active: cfg.active, percent: Number(cfg.percent) || 0, frequency: cfg.frequency })).data); toast.success("Regras salvas"); } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  const regen = async () => {
    if (!window.confirm("Gerar um novo link? O link antigo deixa de funcionar para novos cadastros.")) return;
    try { setCfg((await adminApi.post("/referrals/config/invite")).data); toast.success("Novo link gerado"); } catch (e) { toast.error(errMsg(e)); }
  };
  const copy = () => navigator.clipboard.writeText(cfg.signup_url).then(() => toast.success("Link copiado"));
  return (
    <div className="grid gap-4 lg:grid-cols-2">
      <div className="card-surface space-y-4 p-5" data-testid="referral-config-card">
        <p className="eyebrow">Regras do programa</p>
        <label className="flex items-center gap-3 text-sm"><Switch checked={cfg.active} onCheckedChange={(v) => setCfg({ ...cfg, active: v })} data-testid="referral-active-switch" />Programa {cfg.active ? "ativo" : "inativo"}</label>
        <div className="grid gap-3 sm:grid-cols-2">
          <div className="space-y-1.5"><Label>Comissão (%)</Label><Input type="number" min="0" max="100" step="0.5" value={cfg.percent} onChange={(e) => setCfg({ ...cfg, percent: e.target.value })} data-testid="referral-percent-input" /></div>
          <div className="space-y-1.5"><Label>Fechamento</Label>
            <select value={cfg.frequency} onChange={(e) => setCfg({ ...cfg, frequency: e.target.value })} className="h-10 w-full rounded-md border bg-transparent px-3 text-sm" data-testid="referral-frequency-select">
              {Object.entries(cfg.frequencies).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
            </select></div>
        </div>
        <p className="text-xs text-muted-foreground">A comissão vale sobre cada mensalidade paga pelo cliente indicado. Semanal fecha no domingo, quinzenal nos dias 15 e último do mês, mensal no último dia do mês.</p>
        <Button onClick={save} disabled={busy} data-testid="referral-config-save-btn">{busy ? "Salvando..." : "Salvar regras"}</Button>
      </div>
      <div className="card-surface space-y-3 p-5" data-testid="referral-partner-link-card">
        <p className="eyebrow">Link de cadastro de parceiros</p>
        <p className="text-sm text-muted-foreground">Copie e envie para quem quiser indicar sem ter plano. A pessoa preenche nome, e-mail e chave Pix e recebe o link de indicação dela.</p>
        <Input readOnly value={cfg.signup_url} onFocus={(e) => e.target.select()} className="font-mono text-xs" data-testid="referral-partner-link-input" />
        <div className="flex flex-wrap gap-2">
          <Button onClick={copy} data-testid="referral-partner-link-copy-btn"><Copy className="mr-1 h-4 w-4" />Copiar link</Button>
          <Button variant="outline" onClick={regen} data-testid="referral-partner-link-regen-btn"><RefreshCw className="mr-1 h-4 w-4" />Gerar novo link</Button>
        </div>
      </div>
    </div>
  );
}
